import SurveyTip from 'components/pages/SurveyTip/SurveyTip';
import { buildPage } from 'utils/pageHelper';
import { GetStaticPaths, GetStaticProps } from 'next/types';
import surveyTips from 'constants/surveyTips';

export default buildPage(SurveyTip, {
  requiresAuthentication: false,
  withNestedMetaData: true,
  fullPage: true,
});

function generateSurveyTips(locale: string | undefined = undefined) {
  return surveyTips.map((tip) => ({
    params: { surveyTipSlug: tip.path },
    locale,
  }));
}

export const getStaticPaths: GetStaticPaths = async function getStaticPaths(context) {
  const surveyTips = (context.locales || []).reduce((acc, locale) => {
    return [...acc, ...generateSurveyTips(locale)];
  }, generateSurveyTips());

  return {
    paths: surveyTips,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const surveyTipSlug = params?.surveyTipSlug as string;
  const surveyTipIndex = surveyTips.map((tip) => tip.path).indexOf(surveyTipSlug);

  return {
    props: {
      surveyTips,
      surveyTipIndex,
    },
  };
};
